import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import { FC } from 'react';

const AppRadioGroup: FC<IAppRadioGroupProps> = (props) => {
    const {
        labelGroup,
        register,
        name,
        setValue,
        watch,
        rules,
        row,
        dataRadio,
        sxRadioGroup,
        onChangeCallback,
        value,
        disable,
    } = props;

    return (
        <FormControl sx={{ width: '100%' }} disabled={disable}>
            {labelGroup && (
                <FormLabel
                    sx={{
                        fontFamily: 'Meiryo',
                        fontSize: 18,
                        fontWeight: 400,
                        color: 'var(--color-49454f)',
                        '&.Mui-focused': { color: 'var(--color-49454f)' },
                    }}
                    id={labelGroup}>
                    {labelGroup}
                </FormLabel>
            )}
            <RadioGroup
                row={row}
                sx={{ width: '100%', justifyContent: 'space-between', ...sxRadioGroup }}
                {...(register ? register(name, rules) : {})}
                aria-labelledby={labelGroup}
                {...(watch ? { value: watch(name) } : { value: value })}
                {...(setValue
                    ? {
                          onChange(_, value) {
                              setValue(name, value);
                          },
                      }
                    : { onChange: onChangeCallback })}
                name={name}>
                {dataRadio.map((e, i) => (
                    <FormControlLabel
                        key={i}
                        value={e.value}
                        control={
                            <Radio
                                size="medium"
                                sx={{
                                    '&.Mui-checked': {
                                        color: 'var(--color-16c47f)',
                                    },
                                }}
                            />
                        }
                        label={e.label}
                        sx={{
                            '& .MuiFormControlLabel-label': {
                                fontFamily: 'Meiryo',
                                fontWeight: 400,
                                fontSize: '16px',
                            },
                        }}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
};

export { AppRadioGroup };
